var _defs, _style, _use;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconionicMdRadioButtonOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon ionic-md-radio-button-on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 20,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IB2cksfwAAADxQTFRFAAAAM5b/MpX/M5X/M5X/MJT/MpX/MpX/MpT/MpT/MJX/MpT/MpX/MJP/M5T/M5T/MpT/MpX/M5X/M5X/41R+aQAAABR0Uk5TAFCfz/9P35DgcDCPgEC/oNDAsG9YSQhIAAAAmklEQVR4nG1QQQKDIAxrJcPiQGD+/6+jVdA5e4KQpCFENjw5wE0vOoc9jvHcsRmQsBAtQYD3wEJ/D0A0LbCcTglQBzFeWoE1GdcrUdox7nuikZiyElPfnpSaqahj7WBtGeAIaBKMscsz+Cv/qLw8L2LNdY/UwzeHuoeXv2/y/k0tZLsUMo+a/KbVbf4oyTTStwvTxSoXoOQD+gKf9wXhOZVYrwAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicMdRadioButtonOn);
export default __webpack_public_path__ + "static/media/Icon ionic-md-radio-button-on.2c74001e35652e541f78327e288ee064.svg";
export { ForwardRef as ReactComponent };